import { qs, qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import { backgroundVideoHandler } from "@/lib/a11y";
import playButtonBlock from "@/lib/play-button-block";
import { animateVideoHero, shouldAnimate } from "@/lib/animation";
import checkAutoPlay from "../lib/checkAutoPlay";
import atBreakpointChange from "@/lib/at-breakpoint-change";
import { getMediaQuery } from "@/lib/media-queries";

const selectors = {
  mediaContainer: ".video-hero__media-container",
  video: ".video-hero__video",
  videoDefaultTemplate: "#default-video-template",
  videoMobileTemplate: "#mobile-video-template",
  currentVideoContainer: ".current-video-container",
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};

section("video-hero", {
  videoHandler: null,
  onLoad() {
    const playButtonVideos = qsa(selectors.playButtonVideo, this.container);
    this.mediaContainer = qs(selectors.mediaContainer, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block =>
        playButtonBlock(block.closest(selectors.playButtonBlock))
      );
    }

    const hasVideo = this.mediaContainer.dataset.hasVideo === "true";
    const hasMobileVideo =
      this.mediaContainer.dataset.hasMobileVideo === "true";

    if (hasMobileVideo) {
      if (window.matchMedia(getMediaQuery("below-720")).matches) {
        this._updateVideoTemplate("mobile");
      } else {
        this._updateVideoTemplate("default");
      }

      atBreakpointChange(720, () => {
        if (window.matchMedia(getMediaQuery("below-720")).matches) {
          this._updateVideoTemplate("mobile");
        } else {
          this._updateVideoTemplate("default");
        }
      });
    } else if (hasVideo) {
      this._updateVideoTemplate("default");
    }

    if (shouldAnimate(this.container)) {
      this.animateVideoHero = animateVideoHero(this.container);
    }
  },

  _updateVideoTemplate(videoType) {
    const currentVideoContainer = qs(
      selectors.currentVideoContainer,
      this.container
    );

    const videoTemplateSelector =
      videoType === "mobile"
        ? selectors.videoMobileTemplate
        : selectors.videoDefaultTemplate;

    const videoTemplate = qs(videoTemplateSelector, this.mediaContainer);
    const currentVideoTemplate = videoTemplate.content.cloneNode(true);
    const currentVideoEl = qs(selectors.video, currentVideoTemplate);

    // Manual reset of mute attr required for most browsers to autoplay
    if (currentVideoEl) {
      currentVideoEl.muted = true;
    }

    currentVideoContainer.innerHTML = "";
    currentVideoContainer.appendChild(currentVideoTemplate);

    this._playVideo(currentVideoEl);
  },

  _playVideo(video) {
    this.videoHandler = backgroundVideoHandler(this.container);

    // play function is required for mobile & Safari or video will stay paused
    if (video) {
      video.play();
      checkAutoPlay(video, this.mediaContainer);
    }

    // if video is still not ready, show the fallback image
    if (video && video.paused) {
      this.mediaContainer.dataset.videoLoading = "true";
    }
  },

  onUnload() {
    this.playButtons && this.playButtons.forEach(button => button.unload());
    this.videoHandler && this.videoHandler();
    this.animateVideoHero?.destroy();
  },
});
